import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Home from './pages/Home'
import Heritage from './pages/Heritage'
import Gallery from './pages/Gallery'
import RFCP from './pages/RFCP'
import PressRelease from './pages/PressRelease'
import FAQ from './pages/FAQ'

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-[100dvh] flex flex-col overflow-x-clip">
        <Header />
        <main className="flex-grow min-w-0">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/heritage" element={<Heritage />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/rfcp" element={<RFCP />} />
            <Route path="/press-release" element={<PressRelease />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  )
}

export default App
